import { useTranslate } from "ra-core";
import type { Issue } from "../../../../supabase/functions/_shared/automation/validateRule.ts";
import { PARAM_KEYS } from "./ruleModel";

/**
 * FR/EN text for validateRule issues, with their location: "Action 1 (Modèle du texte) — Champ
 * obligatoire.", "Conditions — …", "Règle — …". The missing name has its own message.
 */
export function useIssueText() {
  const t = useTranslate();
  const where = (path: string) => {
    const action = /^actions\.(\d+)(?:\.([a-z_]+))?/.exec(path);
    if (action) {
      const at = t("gavion.automation.issue_at.action", {
        n: Number(action[1]) + 1,
      });
      const param = action[2];
      return param && PARAM_KEYS.has(param)
        ? `${at} (${t(`gavion.automation.params.${param}`)})`
        : at;
    }
    if (path.startsWith("conditions"))
      return t("gavion.automation.issue_at.conditions");
    return t("gavion.automation.issue_at.rule");
  };
  const errorText = (i: Issue) =>
    i.path === "name" && i.code === "required"
      ? t("gavion.automation.errors.name_required")
      : `${where(i.path)} — ${t(`gavion.automation.errors.${i.code}`, { _: i.code })}`;
  const warningText = (i: Issue) =>
    `${where(i.path)} — ${t(`gavion.automation.warnings.${i.code}`, { _: i.code })}`;
  return { errorText, warningText };
}
